export default "__VITE_ASSET__5d100279__"